class FilterableVariants extends HTMLElement {
  constructor() {
    super();

    this.filter = this.querySelector("fv-filter");
    this.variants = Array.from(this.querySelectorAll(".fv-variant"));
    this.grids = this.querySelectorAll("fv-grid");

    this.addEventListener("filterOptionsChanged", ({ detail }) => {
      this.onOptionsChanged(detail.options);
      this.scrollIntoView({ behavior: "smooth" });
    });

    // FIX: Re-apply filters when page is restored from bfcache
    window.addEventListener('pageshow', (event) => {
      if (event.persisted && this.filter) {
        // Trigger filter update when page is loaded from cache
        this.filter.onOptionsChange();
      }
    });
  }

  onOptionsChanged(options) {
      const toCamelCase = (str) =>
        str
          .toLowerCase()
          .replace(/[^a-z0-9]+(.)/g, (_, char) => char.toUpperCase());
    
      const isFilterEmpty = Object.values(options).every((o) => o.length === 0);
    
      this.variants.forEach((variant) => {
        const shouldShow =
          isFilterEmpty ||
          Object.keys(options).every((key) => {
            const normalizedKey = toCamelCase(key);
            const variantValue = variant.dataset[normalizedKey];
            const optionValues = options[key];
    
            console.log(variantValue, optionValues, "hi");
    
            return optionValues.length === 0 ||
              (variantValue && optionValues.includes(variantValue));
          });
    
        variant.classList.toggle("hidden", !shouldShow);
      });
    
      this.grids.forEach((grid) => grid.onOptionsChanged(options));
    }
}
  
  class FilterableVariantsGrid extends HTMLElement {
    constructor() {
      super();
    }
  
    onOptionsChanged(options) {
      Object.keys(options).forEach((optionKey) => {
        if (options[optionKey].length > 1) {
          [...this.children]
            .sort(
              (a, b) =>
                options[optionKey].findIndex((o) => o === a.dataset[optionKey]) -
                options[optionKey].findIndex((o) => o === b.dataset[optionKey])
            )
            .forEach((node) => this.appendChild(node));
        }
      });
    }
  }
  
  class FilterableVariantsFilter extends HTMLElement {
    constructor() {
      super();
  
      this.options = Array.from(this.querySelectorAll("input[type=checkbox]"));
      this.clearButton = this.querySelector(".fv-filter__clear");
      this.viewAllButtons = document.querySelectorAll(".filterable-variants__expand");
  
      // Dynamically initialize selectedOptions based on actual options in UI
      this.selectedOptions = this.getInitialOptionsState();
  
      this.clearButton.addEventListener("click", this.clear.bind(this));
      this.viewAllButtons.forEach((button) =>
        button.addEventListener("click", this.clear.bind(this))
      );
  
      this.options.forEach((option) =>
        option.addEventListener("change", this.toggleOption.bind(this))
      );
    }
  
    getInitialOptionsState() {
      const optionsState = {};
      this.options.forEach((option) => {
        const optionKey = option.name;
        if (!optionsState[optionKey]) {
          optionsState[optionKey] = [];
        }
      });
      return optionsState;
    }
  
    toggleOption(e) {
      const { name: option, value, checked } = e.target;
  
      if (checked) this.onSelectOption(option, value);
      else this.onDeselectOption(option, value);
  
      this.onOptionsChange();
    }
  
    onSelectOption(option, value) {
      if (!this.selectedOptions[option]) {
        this.selectedOptions[option] = [];
      }
      this.selectedOptions[option].unshift(value);
    }
  
    onDeselectOption(option, value) {
      this.selectedOptions[option] = this.selectedOptions[option].filter(
        (o) => o !== value
      );
    }
  
    onOptionsChange() {
      const hasActiveFilters = Object.values(this.selectedOptions).some((o) => o.length > 0);
  
      this.clearButton.disabled = !hasActiveFilters;
      this.viewAllButtons.forEach((b) => (b.disabled = !hasActiveFilters));
  
      this.dispatchEvent(
        new CustomEvent("filterOptionsChanged", {
          detail: { options: this.selectedOptions },
          bubbles: true,
        })
      );
    }
  
    clear() {
      this.options.forEach((option) => (option.checked = false));
      this.selectedOptions = this.getInitialOptionsState();
      this.onOptionsChange();
    }
  }
  
  // Register custom elements only if they are not already defined
  if (!customElements.get("fv-grid")) customElements.define("fv-grid", FilterableVariantsGrid);
  if (!customElements.get("filterable-variants"))
    customElements.define("filterable-variants", FilterableVariants);
  if (!customElements.get("fv-filter")) customElements.define("fv-filter", FilterableVariantsFilter);

const MODULE_HANDLES = ['eclipse-sofa-module', 'everyday-sofa-module'];
const MODULE_GROUPS_TO_HIDE = ['size', 'configuration'];
const AUX_GROUPS = ['size', 'shape', 'colour-group'];

class SofaCollectionFilterable extends FilterableVariants {
  constructor() {
    super();

    // Override base-class variant query — sofa-collection mode uses a separate
    // class namespace (`.sofa-card`) so existing `.fv-variant*` styles can't bleed in.
    this.variants = Array.from(this.querySelectorAll('.sofa-card'));

    this.priceMin    = this.querySelector('[name="price-min"]');
    this.priceMax    = this.querySelector('[name="price-max"]');
    this.priceApply  = this.querySelector('.fv-filter__price-apply');
    this.drawerEl    = this.querySelector('.fv-filter--sofa-collection');
    this.drawerOpen  = this.querySelector('.fv-drawer-toggle');
    this.drawerClose = this.querySelector('.fv-filter__close');
    this.backdrop    = this.querySelector('.fv-filter__backdrop');
    this.countBadge  = this.querySelector('.fv-filter__count');
    this.toggleCount = this.querySelector('.fv-drawer-toggle__count');
    this.empty       = this.querySelector('.fv-empty');
    this.emptyClear  = this.querySelector('.fv-empty__clear');

    this.priceState = { min: null, max: null };
    this.lastOptions = {};

    this.priceApply?.addEventListener('click', () => this.onPriceChange());
    this.priceMin?.addEventListener('change', () => this.onPriceChange());
    this.priceMax?.addEventListener('change', () => this.onPriceChange());

    this._initPriceSlider();
    this.drawerOpen?.addEventListener('click', () => this.openDrawer());
    this.drawerClose?.addEventListener('click', () => this.closeDrawer());
    this.backdrop?.addEventListener('click', () => this.closeDrawer());
    this.emptyClear?.addEventListener('click', () => this.filter?.clear?.());
    window.addEventListener('pagehide', () => this.closeDrawer());

    // "All" sofa toggle: mutually exclusive with individual product checkboxes.
    this.allSofaCheckbox = this.querySelector('[data-sofa-all]');
    this.productCheckboxes = Array.from(this.querySelectorAll('input[name="product"]'));

    this.allSofaCheckbox?.addEventListener('change', () => {
      if (this.allSofaCheckbox.checked) {
        // Selecting All: uncheck every individual product (and trigger their change
        // handlers so the base class clears its product[] state).
        this.productCheckboxes.forEach(cb => {
          if (cb.checked) {
            cb.checked = false;
            cb.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      } else {
        // User unchecked All directly. If no individual is selected, force-recheck
        // (we never let the Sofa group be entirely empty).
        const anySelected = this.productCheckboxes.some(cb => cb.checked);
        if (!anySelected) this.allSofaCheckbox.checked = true;
      }
    });

    this.productCheckboxes.forEach(cb => {
      cb.addEventListener('change', () => {
        if (cb.checked) {
          this._clearAuxFilters();
          if (this.allSofaCheckbox && this.allSofaCheckbox.checked) {
            this.allSofaCheckbox.checked = false;
          }
        } else {
          // If user unchecked the last individual, snap back to All.
          const anySelected = this.productCheckboxes.some(c => c.checked);
          if (!anySelected && this.allSofaCheckbox) {
            this.allSofaCheckbox.checked = true;
          }
        }
      });
    });

    // Initial availability calc — disables values that can't possibly match anything
    // (e.g., a configuration value that doesn't exist on any visible variant).
    requestAnimationFrame(() => {
      this._updateAvailability();
      this._updateModuleBlocking();
      this._updateModuleGroupHiding();
    });
  }

  onOptionsChanged(options) {
    this.lastOptions = options || {};
    // The "All" checkbox has no name attribute, so the base class records
    // its state under the empty-string key — strip it before filtering.
    delete this.lastOptions[''];
    this.applyFilters();
  }

  onPriceChange() {
    const minVal = parseFloat(this.priceMin?.value);
    const maxVal = parseFloat(this.priceMax?.value);
    this.priceState.min = Number.isNaN(minVal) ? null : minVal;
    this.priceState.max = Number.isNaN(maxVal) ? null : maxVal;
    this.applyFilters();
  }

  _initPriceSlider() {
    const slider = this.querySelector('.fv-filter__price-slider');
    if (!slider) return;

    const minThumb = slider.querySelector('.fv-filter__price-slider-thumb--min');
    const maxThumb = slider.querySelector('.fv-filter__price-slider-thumb--max');
    const fill = slider.querySelector('.fv-filter__price-slider-fill');
    const rangeMin = parseFloat(slider.dataset.min);
    const rangeMax = parseFloat(slider.dataset.max);
    if (!minThumb || !maxThumb || !fill || !Number.isFinite(rangeMin) || !Number.isFinite(rangeMax)) return;

    this._priceSliderMinThumb = minThumb;
    this._priceSliderMaxThumb = maxThumb;
    this._priceSliderRange = { min: rangeMin, max: rangeMax };

    const span = (rangeMax - rangeMin) || 1;

    const paintFill = () => {
      let lo = parseFloat(minThumb.value);
      let hi = parseFloat(maxThumb.value);
      if (lo > hi) { [lo, hi] = [hi, lo]; }
      fill.style.left  = `${((lo - rangeMin) / span) * 100}%`;
      fill.style.right = `${((rangeMax - hi) / span) * 100}%`;
    };

    this._repaintPriceSlider = paintFill;

    const syncToInputs = () => {
      let lo = parseFloat(minThumb.value);
      let hi = parseFloat(maxThumb.value);
      if (lo > hi) {
        minThumb.value = hi;
        maxThumb.value = lo;
        lo = parseFloat(minThumb.value);
        hi = parseFloat(maxThumb.value);
      }
      if (this.priceMin) this.priceMin.value = lo;
      if (this.priceMax) this.priceMax.value = hi;
    };

    minThumb.addEventListener('input', paintFill);
    maxThumb.addEventListener('input', paintFill);
    minThumb.addEventListener('change', () => { syncToInputs(); this.onPriceChange(); });
    maxThumb.addEventListener('change', () => { syncToInputs(); this.onPriceChange(); });

    this.priceMin?.addEventListener('change', () => {
      const v = parseFloat(this.priceMin.value);
      if (Number.isFinite(v)) minThumb.value = Math.max(rangeMin, Math.min(rangeMax, v));
      paintFill();
    });
    this.priceMax?.addEventListener('change', () => {
      const v = parseFloat(this.priceMax.value);
      if (Number.isFinite(v)) maxThumb.value = Math.max(rangeMin, Math.min(rangeMax, v));
      paintFill();
    });

    paintFill();
  }

  applyFilters() {
    const options = this.lastOptions || {};
    const optionsEmpty = Object.values(options).every(o => !o.length);
    const hasPrice = this.priceState.min != null || this.priceState.max != null;

    let visibleCount = 0;

    this.variants.forEach(variant => {
      const matchesOptions = optionsEmpty || Object.keys(options).every(key => {
        const values = options[key];
        if (!values || !values.length) return true;
        const dataKey = this._toCamelCase(key);
        return values.includes(variant.dataset[dataKey]);
      });

      const price = parseFloat(variant.dataset.price);
      const matchesPrice = !hasPrice ||
        ((this.priceState.min == null || price >= this.priceState.min) &&
         (this.priceState.max == null || price <= this.priceState.max));

      const show = matchesOptions && matchesPrice;
      variant.classList.toggle('hidden', !show);
      if (show) visibleCount++;
    });

    this.empty?.classList.toggle('is-visible', visibleCount === 0);
    this._updateCount(options, hasPrice);
    this._updateAvailability();
    this._updateModuleBlocking();
    this._updateModuleGroupHiding();
  }

  /**
   * For each Size / Configuration / Colour-group checkbox, count how many cards
   * would remain visible if that one row were ticked alongside everything else
   * currently selected. Write the count onto the row's wrapper (data-count) and
   * into the label's count-suffix span. CSS hides rows with count=0 unless
   * they're checked.
   *
   * Sofa rows and the All toggle are exempt — they're always clickable.
   * Already-checked rows always show their current count (so the user can see
   * "(0)" and untick a stale-zero selection).
   */
  _updateAvailability() {
    const checkboxes = Array.from(this.querySelectorAll('.fv-filter--sofa-collection input[type="checkbox"]'));
    const hasPrice = this.priceState.min != null || this.priceState.max != null;

    // Tracks whether each non-exempt group ended up with at least one visible row.
    const groupHasVisibleRow = {};

    checkboxes.forEach(cb => {
      const wrapper = cb.parentElement;

      // Always-enabled exemptions: Sofa filter, the All toggle, anything unnamed.
      if (!cb.name || cb.name === 'product') {
        wrapper?.removeAttribute('data-count');
        return;
      }

      // Build a hypothetical selection: candidate value replaces this group's
      // current selection; other groups keep theirs.
      const groupName = cb.name;
      const candidate = cb.value;
      const hypothetical = {};
      Object.keys(this.lastOptions || {}).forEach(k => {
        if (!k) return;
        hypothetical[k] = (k === groupName) ? [candidate] : [...(this.lastOptions[k] || [])];
      });
      if (!(groupName in hypothetical)) hypothetical[groupName] = [candidate];

      let matchCount = 0;
      this.variants.forEach(variant => {
        const matchesOptions = Object.keys(hypothetical).every(key => {
          const values = hypothetical[key];
          if (!values.length) return true;
          return values.includes(variant.dataset[this._toCamelCase(key)]);
        });
        if (!matchesOptions) return;
        if (hasPrice) {
          const price = parseFloat(variant.dataset.price);
          if (this.priceState.min != null && !(price >= this.priceState.min)) return;
          if (this.priceState.max != null && !(price <= this.priceState.max)) return;
        }
        matchCount++;
      });

      wrapper?.setAttribute('data-count', String(matchCount));

      // Update the count suffix inside the label, e.g. " (4)".
      const suffix = wrapper?.querySelector('.fv-filter__count-suffix');
      if (suffix) suffix.textContent = ` (${matchCount})`;

      // A row counts as "visible" for group-level visibility purposes if it has
      // matches OR is currently checked (we keep checked-zero rows visible so
      // the user can untick).
      if (matchCount > 0 || cb.checked) {
        groupHasVisibleRow[groupName] = true;
      } else if (!(groupName in groupHasVisibleRow)) {
        groupHasVisibleRow[groupName] = false;
      }
    });

    // Group-level visibility: hide a `<details>` group if every row inside is
    // hidden (count=0 and unchecked). Iterate the named groups we touched.
    Object.keys(groupHasVisibleRow).forEach(name => {
      const groupEl = this.querySelector(`details.fv-filter__group:has(input[name="${name}"])`);
      if (!groupEl) return;
      if (groupHasVisibleRow[name]) {
        groupEl.removeAttribute('data-count');
      } else {
        groupEl.setAttribute('data-count', '0');
      }
    });
  }

  /**
   * Rule C — When one Module is checked, hard-disable the other Module's checkbox
   * (greyed + line-through via existing `is-disabled` CSS, native `disabled` attribute
   * for click-block + a11y). When no Module is checked, both are enabled.
   * Recomputed from scratch each tick — there's no stateful event handler.
   */
  _updateModuleBlocking() {
    const checkedModule = MODULE_HANDLES.find(handle =>
      this.productCheckboxes.some(cb => cb.value === handle && cb.checked)
    );

    MODULE_HANDLES.forEach(handle => {
      const input = this.productCheckboxes.find(cb => cb.value === handle);
      if (!input) return;
      const wrapper = input.closest('.fv-filter__button-filter');
      const shouldBlock = !!checkedModule && handle !== checkedModule;
      input.disabled = shouldBlock;
      wrapper?.classList.toggle('is-disabled', shouldBlock);
    });
  }

  /**
   * Rule B2 — When the active Sofa selection contains *only* Module products,
   * force-hide the Size and Configuration groups via `data-count="0"` on their
   * `<details>` wrappers. Set-only: `_updateAvailability()` (which runs first in
   * the same tick) is the canonical writer/clearer for `data-count` on group
   * elements; this method only escalates when needed.
   */
  _updateModuleGroupHiding() {
    const productSel = (this.lastOptions && this.lastOptions['product']) || [];
    const modulesOnly = productSel.length > 0 &&
      productSel.every(v => MODULE_HANDLES.includes(v));

    if (!modulesOnly) return;

    MODULE_GROUPS_TO_HIDE.forEach(name => {
      const groupEl = this.querySelector(`details.fv-filter__group--${name}`);
      if (groupEl) groupEl.setAttribute('data-count', '0');
    });
  }

  /**
   * Clear all auxiliary filter selections (Size, Configuration/shape, Colour) and
   * reset price to the slider's range bounds. Issues a single `filterOptionsChanged`
   * event so the standard re-render pipeline runs once.
   *
   * Called when the user CHECKS an individual sofa product (Sofa group itself is
   * intentionally left untouched). Does nothing for unchecks or for the "All" toggle.
   */
  _clearAuxFilters() {
    // 1. Uncheck every checkbox in the auxiliary groups (DOM only — no per-checkbox
    //    change events; we collapse to a single re-render at the end).
    const auxSelector = AUX_GROUPS.map(name => `input[name="${name}"]`).join(',');
    this.querySelectorAll(auxSelector).forEach(input => {
      if (input.checked) input.checked = false;
    });

    // 2. Reset the base filter's tracked state for the same groups.
    if (this.filter && this.filter.selectedOptions) {
      AUX_GROUPS.forEach(name => {
        this.filter.selectedOptions[name] = [];
      });
    }

    // 3. Reset price state and inputs.
    this.priceState = { min: null, max: null };
    if (this._priceSliderRange) {
      const { min: rangeMin, max: rangeMax } = this._priceSliderRange;
      if (this.priceMin) this.priceMin.value = rangeMin;
      if (this.priceMax) this.priceMax.value = rangeMax;
      if (this._priceSliderMinThumb) this._priceSliderMinThumb.value = rangeMin;
      if (this._priceSliderMaxThumb) this._priceSliderMaxThumb.value = rangeMax;
      this._repaintPriceSlider?.();
    }

    // 4. Trigger one re-render through the normal pipeline.
    this.filter?.onOptionsChange?.();
  }

  _updateCount(options, hasPrice) {
    const total = Object.values(options).reduce((n, arr) => n + (arr?.length || 0), 0) + (hasPrice ? 1 : 0);
    [this.countBadge, this.toggleCount].forEach(el => {
      if (!el) return;
      el.textContent = total;
      el.classList.toggle('is-visible', total > 0);
    });
  }

  openDrawer() {
    this.drawerEl?.classList.add('is-open');
    this.classList.add('is-drawer-open');
    document.body.classList.add('fv-no-scroll');
  }

  closeDrawer() {
    this.drawerEl?.classList.remove('is-open');
    this.classList.remove('is-drawer-open');
    document.body.classList.remove('fv-no-scroll');
  }

  _toCamelCase(s) {
    return s.toLowerCase().replace(/[^a-z0-9]+(.)/g, (_, c) => c.toUpperCase());
  }
}

if (!customElements.get('sofa-collection-filterable')) {
  customElements.define('sofa-collection-filterable', SofaCollectionFilterable);
}
